import { render, staticRenderFns } from "./RolePermissionModal.vue?vue&type=template&id=71372de1&scoped=true&"
import script from "./RolePermissionModal.vue?vue&type=script&lang=js&"
export * from "./RolePermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71372de1",
  null
  
)

export default component.exports